import React from 'react';

// BirrPlug brand mark: a power plug with a lightning bolt, plus wordmark.
// Rendered inline so the gradient + font always match the theme.
export function BpMark({ size = 34 }) {
    return (
        <svg width={size} height={size} viewBox="0 0 48 48" fill="none" aria-hidden="true">
            <defs>
                <linearGradient id="bpg" x1="0" y1="0" x2="48" y2="48" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#4facfe" />
                    <stop offset="1" stopColor="#00f2fe" />
                </linearGradient>
            </defs>
            {/* plug body */}
            <rect x="10" y="16" width="28" height="20" rx="7" stroke="url(#bpg)" strokeWidth="3" />
            {/* prongs */}
            <path d="M17 16V8M31 16V8" stroke="url(#bpg)" strokeWidth="3" strokeLinecap="round" />
            {/* cord */}
            <path d="M24 36v6" stroke="url(#bpg)" strokeWidth="3" strokeLinecap="round" />
            {/* bolt */}
            <path d="M25.5 20l-5 7h3.5l-1.5 5 5-7H24l1.5-5z" fill="url(#bpg)" />
        </svg>
    );
}

export default function BpLogo({ size = 34, className = '' }) {
    return (
        <span className={`bp-logo ${className}`}>
            <BpMark size={size} />
            <span className="bp-logo-word">Birr<em>Plug</em></span>
        </span>
    );
}
